<script lang="ts" setup>
import { ProductInterface } from '../../models/ProductModel'
import ASpinner from '../common/ASpinner.vue'
import AButton from '../common/AButton.vue'
import { ref } from 'vue'

const props = withDefaults(defineProps<Props>(), {
  product: null,
})

const quantity = ref<number>(1)
const isNew = props.product?.quantity === 0

const emit = defineEmits<{
  productUpdated: [product: ProductInterface]
}>()

interface Props {
  product?: null | ProductInterface
}

function removeProduct() {
  const updatedProduct: ProductInterface = {
    ...props.product,
    quantity: 0,
  }
  emit('productUpdated', updatedProduct)
}

function updateProduct() {
  const currentQuantity = props.product?.quantity ?? 0
  const newQuantity = quantity.value + currentQuantity
  const updatedProduct: ProductInterface = {
    ...props.product,
    quantity: newQuantity > 0 ? newQuantity : 0,
  }

  emit('productUpdated', updatedProduct)
}
</script>

<template>
  <div v-if="props.product">
    <b>{{ props.product.name }}</b>
    <div>
      <small
        >{{ $t('code') }}:&nbsp;{{ product.code }} | {{ $t('barcode') }}:&nbsp;{{
          product.barcode
        }}</small
      >
    </div>
    <div class="pt-16">
      <ASpinner
        v-model="quantity"
        :label="String($t('quantity'))"
        :auto-focus="true"
        :allow-negative="true"
      >
        <template #extraButton>
          <div class="d-flex gap-12 w-100">
            <AButton class="btn-danger flex-1" @click="removeProduct">
              {{ $t(isNew ? 'cancel' : 'delete') }}
            </AButton>
            <AButton class="btn-warning flex-1" @click="updateProduct">
              {{ $t('confirm') }}
            </AButton>
          </div>
        </template>
      </ASpinner>
    </div>
  </div>
</template>
